import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PromotionCurrency } from '@core/models/promotion-currency.model';
import { AbstractControl, FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, Subscription, forkJoin } from 'rxjs';
import { PromotionCurrencyDataService } from '../services/promotion-currency-data.service';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { PromotionCurrencyEntityService } from '../services/promotion-currency-entity.service';
import { tap, catchError, map, filter } from 'rxjs/operators';
import { PromoTypePipe } from '@core/pipes/promo-type.pipe';
import { Status } from '@core/enums/status.enum';
import { GameProviderHttpService } from '@core/services/game-provider-http.service';

interface PromotionCurrencyDetailsDialogData {
  promotionCurrency: any;
  promotionCode: any;
  mode: string;
  promotionId: number;
  promotionType: any;
  promoSubType: number;
  promotionCodeMode: string;
  promotionCurrencyRow: any;
  promotionCodeP1: any;
}

interface FreeRoundBetValue {
  value: any;
  label: string;
}

@Component({
  selector: 'kt-promotion-currency',
  templateUrl: './promotion-currency-details.component.html',
  styleUrls: ['./promotion-currency-details.component.scss']
})
export class PromotionCurrencyDetailsComponent implements OnInit, OnDestroy {

  status = Status;
  form: FormGroup;
  dropdown = {
    currencies: JSON.parse(sessionStorage.getItem('currencies')) === null ? [] : JSON.parse(sessionStorage.getItem('currencies')),
    statuses: this.dropdownHttpService.statuses
  };
  messages$ = this.promotionCurrencyDataService.messages$;
  freeRoundBetValuesMessages$ = new Subject<any[]>();
  private subscription = new Subscription();
  private messageSubscription = new Subscription();
  private betValuesCurrencySubscription = new Subscription();
  private betValuesRequestSubscription = new Subscription();
  refreshStatus: boolean;
  promotionType = this.data.promotionType;
  buttonLoading = false;
  fieldDisabled = false;
  shouldUseBetValuesDropdown = false;
  freeRoundBetValues: FreeRoundBetValue[] = [];
  freeRoundBetValuesLoading = false;

  targetType = [
    {
      value: '7',
      label: 'Winover'
    },
    {
      value: '6',
      label: 'Turnover'
    }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PromotionCurrencyDetailsDialogData,
    private promotionCurrencyDataService: PromotionCurrencyDataService,
    private promotionCurrencyEntitySerice: PromotionCurrencyEntityService,
    private dropdownHttpService: DropdownHttpService,
    public dialogRef: MatDialogRef<PromotionCurrencyDetailsComponent>,
    private promoTypePipe: PromoTypePipe,
    private gameProviderHttpService: GameProviderHttpService,
  ) { }

  ngOnInit() {
    this.setCurrency();
    this.formInit();
    this.form.getRawValue();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.messageSubscription.unsubscribe();
    this.betValuesCurrencySubscription.unsubscribe();
    this.betValuesRequestSubscription.unsubscribe();
    this.onRefresh();
  }

 private formInit() {
  let promotionId = null;
  let settingsCurrencyId = null;
  let maxTotalApplication = null;
  let maxTotalBonus= null;
  let minBonus = null;
  let minTransfer = null;
  let minDeposit = null;
  let maxBonus = null;
  let freeCreditAmount = null;
  let maxBalanceClaim = null;
  let currentPlayers = null;
  let usedBudget = null;
  let threshold = null;
  let status = 1;
  let maxTransferOut = null;

  // Free Spin
  let coins = null;
  let amountPerLine = null;
  let rounds = null;
  let lines = null;

  // PP Challege
  let targetAmount = null
  let targetType = 7

  let manualDepositControls = {};
  let freeCreditControls = {};
  let freeSpinControls = {};

  if (this.data.mode === 'edit') {
    promotionId = this.data.promotionCodeMode === 'create' ? null : this.data.promotionCurrency.promotion_id;
    settingsCurrencyId = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.currency_id ?? null : this.data.promotionCurrency.settings_currency_id;
    maxTotalApplication = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.max_total_applications ?? null : this.data.promotionCurrency.max_total_applications;
    maxTotalBonus = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.max_total_bonus ?? null : this.data.promotionCurrency.max_total_bonus;
    minTransfer = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.min_transfer ?? null : this.data.promotionCurrency.min_transfer;
    minDeposit = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.min_deposit : this.data.promotionCurrency.min_deposit;
    maxBonus = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.max_bonus ?? null : this.data.promotionCurrency.max_bonus;
    minBonus = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.min_bonus ?? null : this.data.promotionCurrency.min_bonus;
    freeCreditAmount = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.free_credit_amount ?? null : this.data.promotionCurrency.free_credit_amount;
    maxBalanceClaim = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.max_balance_claim ?? null : this.data.promotionCurrency.max_balance_claim;
    currentPlayers = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.current_players ?? null : this.data.promotionCurrency.current_players;
    usedBudget = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.used_budget ?? null : this.data.promotionCurrency.used_budget;
    coins = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.coins ?? null : this.data.promotionCurrency.coins;
    amountPerLine = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.amount_per_line ?? null : this.data.promotionCurrency.amount_per_line;
    targetAmount = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.target_amount ?? null : this.data.promotionCurrency.target_amount;
    targetType = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.target_type ?? 7 : this.data.promotionCurrency.target_type;
    rounds = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.rounds ?? null : this.data.promotionCurrency.rounds;
    lines = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.lines ?? null : this.data.promotionCurrency.lines;
    threshold = this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.threshold ?? null : this.data.promotionCurrency.threshold;
    status =this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.status ?? null :  this.data.promotionCurrency.status;
    maxTransferOut =this.data.promotionCodeMode === 'create' ? this.data.promotionCurrencyRow.max_transfer_out ?? null :  this.data.promotionCurrency.max_transfer_out;
  }

  // Manual / Deposit
  if(this.promotionType === 1 || this.promotionType === 2) {
    manualDepositControls = {
      ...manualDepositControls,
      min_transfer: new FormControl(minTransfer, [Validators.required]),
      // min_deposit: new FormControl(minDeposit, [Validators.required]),
      max_bonus: new FormControl(maxBonus, [Validators.required]),
      max_total_applications: new FormControl(maxTotalApplication, [Validators.required]),
      max_total_bonus: new FormControl(maxTotalBonus, [Validators.required]),
    }
  }

  // Free Credit
  if(this.promotionType === 3) {
    if (this.promoType('PP_CHALLENGE_PHASE_2')) {
      manualDepositControls = {
        ...manualDepositControls,
        target_amount: new FormControl(targetAmount, [Validators.required]),
        target_type: new FormControl(targetType, [Validators.required]),
      }
    }
    else {
      manualDepositControls = {
        ...manualDepositControls,
        // free_credit_amount: new FormControl(freeCreditAmount, [Validators.required]),
        max_balance_claim: new FormControl(maxBalanceClaim, [Validators.required]),
      }
    }
   
    if (this.data.promoSubType === 3) {
      manualDepositControls = {
        ...manualDepositControls,
        threshold: new FormControl(threshold, [Validators.required]),
        max_total_applications: new FormControl(maxTotalApplication, [Validators.required]),
      }
    } else if (this.data.promoSubType === 2 || this.data.promoSubType === 4) {
      manualDepositControls = {
        ...manualDepositControls,
        min_bonus: new FormControl(minBonus, [Validators.required]),
        max_bonus: new FormControl(maxBonus, [Validators.required]),
      }
    } else {
      manualDepositControls = {
        ...manualDepositControls,
        max_total_applications: new FormControl(maxTotalApplication, [Validators.required]),
        max_total_bonus: new FormControl(maxTotalBonus, [Validators.required]),
        free_credit_amount: new FormControl(freeCreditAmount, [Validators.required]),
      }
    }
  }

  // Free Spin
  if(this.promotionType === 4) {
    if (this.data.promotionCodeMode === 'edit' && this.data.mode === 'edit') {
      this.fieldDisabled = true;
    }
    freeSpinControls = {
      ...freeSpinControls,
      coins: new FormControl({value: coins, disabled: this.fieldDisabled}, [Validators.required]),
      amount_per_line: new FormControl({value: amountPerLine, disabled: this.fieldDisabled}, [Validators.required]),
      rounds: new FormControl({value: rounds, disabled: this.fieldDisabled}, [Validators.required]),
      lines: new FormControl({value: lines, disabled: this.fieldDisabled}, [Validators.required]),
      min_transfer: new FormControl(minTransfer, [Validators.required]),
      // min_deposit: new FormControl({value: minDeposit, disabled: this.fieldDisabled}, [Validators.required]),
      max_total_applications: new FormControl(maxTotalApplication, [Validators.required]),
      max_total_bonus: new FormControl(maxTotalBonus, [Validators.required]),
    }

    if (this.promoType('PP_CHALLENGE_PHASE_1')) {
      freeSpinControls = {
        ...freeSpinControls,
        target_amount: new FormControl({value: targetAmount, disabled: this.fieldDisabled}, [Validators.required]),
      }
    }
  }

  this.form = new FormGroup({
    promotion_id: new FormControl(localStorage.getItem('promoId')), // to refactor soon
    currency_id: new FormControl({
      value: this.data.promotionCodeMode === 'create' && this.promoType('PP_CHALLENGE_PHASE_2')
        ? this.dropdown.currencies.find(x => x.name === this.data.promotionCodeP1.currencies)?.id ?? settingsCurrencyId
        : settingsCurrencyId,
      disabled:
        (this.data.mode === 'edit' && !this.promoType('PP_CHALLENGE_PHASE_1') && !this.promoType('PP_CHALLENGE_PHASE_2')) ||
        (this.data.promotionCodeMode === 'edit' && (this.promoType('PP_CHALLENGE_PHASE_1') || this.promoType('PP_CHALLENGE_PHASE_2'))) ||
        (this.data.promotionCodeMode === 'create' && this.promoType('PP_CHALLENGE_PHASE_2'))
    }, [Validators.required]),
    // max_total_applications: new FormControl(maxTotalApplication, [Validators.required]),
    // max_total_bonus: new FormControl(maxTotalBonus, [Validators.required]),
    // max_bonus: new FormControl(maxBonus, [Validators.required]),
    // min_bonus: new FormControl(minBonus, [Validators.required]),
    // free_credit_amount: new FormControl(freeCreditAmount, [Validators.required]),
    // max_balance_claim: new FormControl(maxBalanceClaim, [Validators.required]),
    ...manualDepositControls,
    ...freeCreditControls,
    ...freeSpinControls,
    status: new FormControl(status, [Validators.required]),
    max_transfer_out: new FormControl(maxTransferOut, [Validators.required, Validators.pattern(/^[0-9]+(\.[0-9]{1,2})?$/)]),
  })

  if (this.promoType('PP_CHALLENGE_PHASE_1')) {
    this.form.get('coins').clearValidators();
    this.form.get('coins').updateValueAndValidity();
    this.form.get('lines').clearValidators();
    this.form.get('lines').updateValueAndValidity();
    this.form.get('min_transfer').clearValidators();
    this.form.get('min_transfer').updateValueAndValidity();
    this.form.get('max_transfer_out').clearValidators();
    this.form.get('max_transfer_out').updateValueAndValidity();
  }

  if (this.promoType('PP_CHALLENGE_PHASE_2')) {
    this.form.get('status')?.disable();
    this.form.get('status').updateValueAndValidity();
    this.form.patchValue({
      max_total_applications: 0,
      max_total_bonus: 0,
    })
  }

  this.setupFreeRoundBetValues();
 }

  private setupFreeRoundBetValues() {
    this.shouldUseBetValuesDropdown = this.canUseFreeRoundBetValues();

    if (!this.shouldUseBetValuesDropdown || !this.form.get('amount_per_line')) {
      return;
    }

    if (this.hasSelectedCurrency(this.form.get('currency_id')?.value)) {
      this.loadFreeRoundBetValues();
    }

    this.betValuesCurrencySubscription = this.form.get('currency_id').valueChanges.subscribe((currencyId) => {
      if (this.hasSelectedCurrency(currencyId)) {
        this.loadFreeRoundBetValues();
      } else {
        this.freeRoundBetValues = [];
        this.freeRoundBetValuesLoading = false;
        this.betValuesRequestSubscription.unsubscribe();
      }
    });

    // invalidBetValue is set manually via setErrors (not a validator), so it won't
    // recompute when the operator picks a value. Clear it once they select a value
    // that is among the bet values returned for the current game/currency.
    const amountPerLineControl = this.form.get('amount_per_line');
    this.betValuesCurrencySubscription.add(
      amountPerLineControl.valueChanges.subscribe((value) => {
        if (this.freeRoundBetValues.some(item => this.isSameBetValue(item.value, value))) {
          this.clearInvalidBetValueError(amountPerLineControl);
        }
      })
    );
  }

  // Providers whose free-spin Amount Per Line is a fixed list from the provider (PTI; JILI2 via
  // its GetGameBetList). Other providers keep free input.
  private static readonly BET_VALUE_PROVIDERS = ['PTI', 'JILI2'];

  private isBetValueProvider(gameProviderCode?: string): boolean {
    return PromotionCurrencyDetailsComponent.BET_VALUE_PROVIDERS.includes((gameProviderCode || '').toUpperCase());
  }

  private canUseFreeRoundBetValues(): boolean {
    const gameProviderCode = this.getFreeSpinGameProviderCode();

    return this.promoType('NORMAL_FREE_SPIN') &&
      this.isBetValueProvider(gameProviderCode) &&
      !!this.getFreeSpinGameCode();
  }

  private loadFreeRoundBetValues() {
    const gameProviderCode = this.getFreeSpinGameProviderCode();
    const gameCode = this.getFreeSpinGameCode();
    const currencyId = this.form.get('currency_id')?.value;

    if (!this.isBetValueProvider(gameProviderCode) || !gameCode || !this.hasSelectedCurrency(currencyId)) {
      this.freeRoundBetValues = [];
      return;
    }

    // Currencies are loaded asynchronously by setCurrency() when the sessionStorage
    // cache is cold. Defer until they are available, otherwise getCurrencyCode()
    // returns null and we'd request bet values for the wrong currency.
    if (this.dropdown.currencies.length === 0) {
      this.freeRoundBetValuesLoading = true;
      this.betValuesRequestSubscription.unsubscribe();
      this.betValuesRequestSubscription = this.dropdownHttpService.currencies.subscribe({
        next: res => {
          if (this.dropdown.currencies.length === 0) {
            this.dropdown.currencies = res ?? [];
          }
          // If the list is still empty (e.g. permissions misconfiguration), bail
          // instead of re-entering this branch and re-requesting indefinitely.
          if (this.dropdown.currencies.length === 0) {
            this.freeRoundBetValues = [];
            this.freeRoundBetValuesLoading = false;
            this.showFreeRoundBetValuesError({ messages: ['Unable to load currencies. Please try again.'] });
            return;
          }
          this.loadFreeRoundBetValues();
        },
        error: error => {
          this.freeRoundBetValues = [];
          this.freeRoundBetValuesLoading = false;
          this.showFreeRoundBetValuesError(error);
        }
      });
      return;
    }

    const currencyCode = this.getCurrencyCode(currencyId);

    this.freeRoundBetValuesLoading = true;
    this.betValuesRequestSubscription.unsubscribe();
    this.betValuesRequestSubscription = this.gameProviderHttpService.getFreeRoundBetValues({
      game_provider_code: gameProviderCode,
      game_code: [gameCode],
      currency: currencyCode,
    }).subscribe({
      next: (values: any[]) => {
        this.freeRoundBetValues = this.normalizeFreeRoundBetValues(values);
        this.applyBetValueDefault();
        this.freeRoundBetValuesLoading = false;
      },
      error: (error) => {
        this.freeRoundBetValues = [];
        this.freeRoundBetValuesLoading = false;
        // Only reset editable bet values on a business-level failure (the service
        // throws res.data with status === 0). Keep currency_id intact because it
        // can be disabled but is still read explicitly during save.
        if (error?.status === 0 && !(error instanceof HttpErrorResponse) && !this.fieldDisabled) {
          this.form.get('amount_per_line')?.setValue(null);
        }
        this.showFreeRoundBetValuesError(error);
      }
    });
  }

  private showFreeRoundBetValuesError(error: any) {
    const messages = Array.isArray(error)
      ? error
      : error?.error?.data?.messages ?? error?.error?.message ?? error?.data?.messages ?? error?.data?.message ?? error?.messages ?? error?.message;

    if (Array.isArray(messages)) {
      this.freeRoundBetValuesMessages$.next(messages);
      return;
    }

    if (messages) {
      this.freeRoundBetValuesMessages$.next([messages]);
      return;
    }

    // The error body matched none of the shapes above (e.g. a plain 404/CORS
    // failure). Still surface something so the user isn't left with a frozen
    // spinner and an empty dropdown.
    this.freeRoundBetValuesMessages$.next(['Failed to load bet values. Please try again.']);
  }

  private normalizeFreeRoundBetValues(values: any[]): FreeRoundBetValue[] {
    const rows = Array.isArray(values) ? values : [];

    return rows
      .map(item => {
        const value = typeof item === 'object'
          ? item.amount_per_line ?? item.bet_value ?? item.betValue ?? item.value ?? item.amount ?? item.bet
          : item;

        if (value === null || value === undefined || value === '') {
          return null;
        }

        return {
          value,
          label: this.formatBetValue(value),
        };
      })
      .filter((item): item is FreeRoundBetValue => !!item);
  }

  private applyBetValueDefault() {
    const control = this.form.get('amount_per_line');
    if (!control) {
      return;
    }

    const currentValue = control.value;
    if (this.freeRoundBetValues.length === 0) {
      return;
    }

    const hasCurrentOption = this.freeRoundBetValues.some(item => this.isSameBetValue(item.value, currentValue));

    if (hasCurrentOption) {
      this.clearInvalidBetValueError(control);
      return;
    }

    if (this.fieldDisabled && currentValue !== null && currentValue !== undefined && currentValue !== '') {
      this.freeRoundBetValues = [
        {
          value: currentValue,
          label: this.formatBetValue(currentValue),
        },
        ...this.freeRoundBetValues,
      ];
      return;
    }

    if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
      control.setErrors({
        ...(control.errors || {}),
        invalidBetValue: true,
      });
      control.markAsTouched();
      this.freeRoundBetValuesMessages$.next(['Amount Per Line is no longer available for the selected game and currency. Please select a valid amount.']);
      return;
    }

    control.setValue(this.freeRoundBetValues[0].value);
  }

  private clearInvalidBetValueError(control: AbstractControl) {
    if (!control.errors?.invalidBetValue) {
      return;
    }

    const errors = { ...control.errors };
    delete errors.invalidBetValue;
    control.setErrors(Object.keys(errors).length ? errors : null);
  }

  private isSameBetValue(optionValue: any, currentValue: any): boolean {
    const optionNumericValue = Number(optionValue);
    const currentNumericValue = Number(currentValue);

    if (!Number.isNaN(optionNumericValue) && !Number.isNaN(currentNumericValue)) {
      return optionNumericValue === currentNumericValue;
    }

    return String(optionValue) === String(currentValue);
  }

  private getFreeSpinGameProviderCode(): string | null {
    return this.data?.promotionCode?.free_spin_game_provider_code ?? this.data?.promotionCode?.phase_game_provider_code ?? null;
  }

  private getFreeSpinGameCode(): string | null {
    return this.data?.promotionCode?.free_spin_game_code ?? this.data?.promotionCodeP1?.free_spin_game_code ?? null;
  }

  private getCurrencyCode(currencyId: any): string | null {
    const currency = this.dropdown.currencies.find(item => +item.id === +currencyId);
    return currency?.name ?? null;
  }

  private hasSelectedCurrency(currencyId: any): boolean {
    return currencyId !== null && currencyId !== undefined && currencyId !== '' && currencyId !== 'null';
  }

  private formatBetValue(value: any): string {
    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? String(value) : numericValue.toFixed(2);
  }

  onSave(promotionCurrencyDetails: PromotionCurrency, mode?: string) {
    let data = {
      id: promotionCurrencyDetails ? promotionCurrencyDetails.id : null,
      ...this.form.value,
      promotion_id: this.data.promotionCodeMode === 'create' ? null : (mode === 'create') ? this.data.promotionId : this.data.promotionCurrency.promotion_id,
      promo_type: this.data.promotionType,
      currency_id: (mode === 'create' || mode === 'edit') ? this.form.get('currency_id').value : this.data.promotionCurrency.settings_currency_id
    };

    if (this.promoType('PP_CHALLENGE_PHASE_1')) {
      data['lines'] = 0;
      data['coins'] = 0;
    }

    if (this.promoType('PP_CHALLENGE_PHASE_2')) {
      data['status'] = 1;
    }
    
    Object.keys(data).forEach((key) => (data[key] == null || data[key] === '') && delete data[key]);
    if(this.data.promotionCodeMode === 'edit'){
      this.buttonLoading = true;
      switch (mode) {
        case 'edit':
          this.subscription = this.promotionCurrencyEntitySerice.update(data).pipe(
            tap((res: any) => {
                this.messages$.next([...res.message]);
                this.buttonLoading = false;
                this.form.setErrors(null);
            }),
            catchError((error) => {
                this.buttonLoading = false;
                this.form.setErrors(null);
                throw error;
            })
          ).subscribe();
        break;
        case 'create':
          this.subscription = this.promotionCurrencyEntitySerice.add(data).pipe(
            tap((res: any) => {
                this.messages$.next([...res.message]);
                this.buttonLoading = false;
                this.form.setErrors(null);
            }),
            catchError((error) => {
                this.buttonLoading = false;
                this.form.setErrors(null);
                throw error;
            })
          ).subscribe();
        break;
      }
      this.refreshStatus = true;
    }else{
      const createPromoCodeCurrencies = localStorage.getItem('createPromoCodeCurrencies');
      if (this.data.mode === 'create' || (this.data.mode === 'create' && this.data.promotionCodeMode === 'create')){
        if (this.form.value.currency_id !== null){
          data = {
            ...data,
            currency: this.dropdown.currencies.find(row => +row.id === +this.form.get('currency_id').value).name,
            current_players: 0,
            used_budget: 0.00,
          };
          let updatedData = [data];

          if (createPromoCodeCurrencies !== null && !this.promoType('PP_CHALLENGE_PHASE_1') && !this.promoType('PP_CHALLENGE_PHASE_2')){
            JSON.parse(createPromoCodeCurrencies).map( (res: any) => {
              updatedData.push(res)
            });
          }
          
          localStorage.setItem('createPromoCodeCurrencies', JSON.stringify(updatedData));
        }
      }else{
        if (createPromoCodeCurrencies !== null){
          let updatedData = JSON.parse(createPromoCodeCurrencies).filter(res => +res.currency_id !== +this.data.promotionCurrencyRow.currency_id)
          data = {
            ...data,
            currency: this.dropdown.currencies.find(row => +row.id === +this.data.promotionCurrencyRow.currency_id).name,
            currency_id: +this.data.promotionCurrencyRow.currency_id,
            current_players: 0,
            used_budget: 0.00,
          };

          if (createPromoCodeCurrencies !== null && !this.promoType('PP_CHALLENGE_PHASE_1') && !this.promoType('PP_CHALLENGE_PHASE_2')){
            updatedData.push(data);
          }
          else {
            updatedData = [data];
          }
          
          localStorage.setItem('createPromoCodeCurrencies', JSON.stringify(updatedData));
        };
      }
      this.dialogRef.close(1);
    }
  }

  onRefresh(){
    if(this.refreshStatus === true){
      this.dialogRef.close(true);
    }
  }

  onCloseDialog(event?: Event ) {
    this.dialogRef.close();
  }

  private setCurrency(){
    const selectCurrency = () => {
      if(this.data.promotionCodeMode === 'create' && this.data.mode === 'create'){
        if (this.data.promotionCurrency.length > 0){
          this.data.promotionCurrency.map( promo => {
            this.dropdown.currencies = this.dropdown.currencies.filter(currency => +currency.id !== +promo.currency_id);
          });
        }
      }
    };

    if(this.dropdown.currencies.length === 0){
      this.dropdownHttpService.currencies.subscribe( res => {
        this.dropdown.currencies = res;
        selectCurrency();
      });
    }else{
      selectCurrency();
    }
  }

  promoType(code: any) {
    return this.promoTypePipe.transform(code, this.promotionType, this.data.promoSubType);
  }
}
